'use client'

import { useState } from 'react'
import { Button } from '@/General/Button'
import { useStore } from '@/store'
import { useAddCustomerToSegmentMutation } from '@/generated/graphql'
import { LoginModal } from '@/MainLayout/Header/TopMenu/LoginModal'
import { toastEmitter } from '@/General/Toast'

// Segment 60 is the blog newsletter segment
const BLOG_NEWSLETTER_SEGMENT_ID = 60

export const NewsletterSignup = () => {
  const userId = useStore(state => state.user?.id)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const { mutate: addToSegment } = useAddCustomerToSegmentMutation({
    onSuccess: () => {
      setIsSubmitted(true)
      setIsLoading(false)
      toastEmitter.emit('toast', {
        title: 'Thanks! You are now signed up.',
        variant: 'success',
      })
    },
    onError: () => {
      setIsLoading(false)
      toastEmitter.emit('toast', {
        title: 'Failed to sign up. Please try again.',
        variant: 'error',
      })
    },
  })

  const handleClick = () => {
    if (!userId) {
      setIsLoginModalOpen(true)
      return
    }

    if (isSubmitted) {
      return
    }

    setIsLoading(true)
    addToSegment({
      segmentId: BLOG_NEWSLETTER_SEGMENT_ID,
    })
  }

  const handleLoginSuccess = () => {
    // After successful login, automatically sign them up
    const newUserId = useStore.getState().user?.id
    if (newUserId) {
      setIsLoading(true)
      addToSegment({
        segmentId: BLOG_NEWSLETTER_SEGMENT_ID,
      })
    }
  }

  if (isSubmitted) {
    return (
      <div className="text-lg bg-gray-100 mt-4 p-4 rounded flex items-center gap-4">
        <svg
          className="w-5 h-5 text-green-600 flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
        <p className="flex-1">Thanks! You are now signed up.</p>
      </div>
    )
  }

  return (
    <>
      <div className="text-lg bg-gray-100 mt-4 p-4 rounded flex items-center gap-4">
        <p className="flex-1">
          Get an email whenever we add a new blog post (only sent a few times a
          week).
        </p>
        <Button
          color="green"
          className="min-w-40"
          onClick={handleClick}
          disabled={isLoading}
        >
          {isLoading ? 'Signing up...' : 'Send me updates'}
        </Button>
      </div>
      <LoginModal
        isLoginOpen={isLoginModalOpen}
        setIsLoginOpen={setIsLoginModalOpen}
        message="Please log in to sign up for blog updates."
        onLoginSuccess={handleLoginSuccess}
      />
    </>
  )
}
